import React from "react";

import { useLocation } from "react-router-dom";

import ServerGroupPerDatabaseQueryPerformance from "features/Queries/ServerGroupPerDatabaseQueryPerformance";
import ServerGroupQueryPerformance from "features/Queries/ServerGroupQueryPerformance";

function ServerGroupQueryOverview() {
  const { search } = useLocation();
  const dbParam = new URLSearchParams(search).get("datname");

  if (dbParam) {
    return <ServerGroupPerDatabaseQueryPerformance datname={dbParam} />;
  }

  return <ServerGroupQueryPerformance />;
}

export default ServerGroupQueryOverview;
